<template>
    <svg class="w-6 h-6 stroke-[#060606]" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 18" fill="none" stroke="currentColor">
        <path d="M1.5 5.5H16.5M14 9H4M10 13H4M4 17H14C15.6569 17 17 15.6569 17 14V4C17 2.34315 15.6569 1 14 1H4C2.34315 1 1 2.34315 1 4V14C1 15.6569 2.34315 17 4 17Z" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
</template>